/* psnm-rv-sidebar.js - On collection pages (desktop only), lift Recently Viewed into the
   left filter sidebar under the facets, as full-width stacked cards (image fills the card
   width, then title/price). Mobile keeps it at the page bottom (sidebar is a hidden drawer).
   Additive. Delete this file + its loader line in snippets/header.nav.liquid to revert. */
(function(){
  var STYLE='.collection-sidebar .psnm-rv-insb{margin-top:18px;padding-top:16px;border-top:1px solid #e5e1d8}'
    +'.collection-sidebar .psnm-rv-insb .index-section,.collection-sidebar .psnm-rv-insb .page-width{padding:0!important;margin:0!important;max-width:none!important}'
    +'.collection-sidebar .psnm-rv-insb .section-header{margin:0 0 12px!important;text-align:left!important}'
    +'.collection-sidebar .psnm-rv-insb .section-header__title{font-size:13px!important;letter-spacing:.06em!important;text-transform:uppercase!important;font-family:Fraunces,Georgia,serif!important;color:#0B2545!important}'
    +'.collection-sidebar .psnm-rv-insb *{word-break:normal!important;overflow-wrap:normal!important;hyphens:none!important}'
    +'.collection-sidebar .psnm-rv-insb .grid-product__title{font-family:Inter,system-ui,sans-serif!important;font-size:13px!important;line-height:1.35!important;white-space:normal!important;text-align:left!important;margin-top:8px!important}'
    +'.collection-sidebar .psnm-rv-insb .grid-product__price{font-family:Inter,system-ui,sans-serif!important;font-size:13px!important;text-align:left!important}'
    +'.collection-sidebar .psnm-rv-insb .grid-product__actions{display:none!important}';
  function injectStyle(){
    if(document.getElementById('psnm-rv-style'))return;
    var s=document.createElement('style');s.id='psnm-rv-style';s.textContent=STYLE;document.head.appendChild(s);
  }
  function setImp(el,p,v){el.style.setProperty(p,v,'important');}
  function styleCards(){
    var wrap=document.querySelector('.psnm-rv-insb');
    if(!wrap)return;
    wrap.querySelectorAll('[id^="RecentlyViewed-"], [id^="RecentlyViewed-"] > *, .grid, .product-grid, .grid--uniform').forEach(function(g){
      setImp(g,'display','block');setImp(g,'width','100%');setImp(g,'max-width','100%');setImp(g,'margin','0');
    });
    var cards=wrap.querySelectorAll('.grid__item, .grid-product, [class*="grid__item"], [id^="RecentlyViewed-"] > * > *');
    cards.forEach(function(c){
      setImp(c,'width','100%');setImp(c,'max-width','100%');setImp(c,'flex','0 0 auto');setImp(c,'float','none');
      setImp(c,'display','block');setImp(c,'margin','0 0 18px');
      var img=c.querySelector('img');
      if(img){setImp(img,'width','100%');setImp(img,'max-width','100%');setImp(img,'height','auto');}
    });
  }
  function move(){
    if(window.innerWidth<990)return false;
    var sb=document.querySelector('.collection-sidebar');
    var rv=document.getElementById('shopify-section-recently-viewed')||document.querySelector('.recently-viewed__section');
    if(!sb||!rv)return false;
    if(!sb.contains(rv)){rv.classList.add('psnm-rv-insb');sb.appendChild(rv);}
    return true;
  }
  var observing=false;
  function observe(){if(observing)return;var wrap=document.querySelector('.psnm-rv-insb');if(!wrap)return;observing=true;new MutationObserver(function(){styleCards();}).observe(wrap,{childList:true,subtree:true});}
  function run(){injectStyle();if(move()){styleCards();observe();}}
  if(document.readyState!=='loading'){run();}else{document.addEventListener('DOMContentLoaded',run);}
  document.addEventListener('shopify:section:load',run);
  var n=0,iv=setInterval(function(){run();if(++n>30){clearInterval(iv);}},300);
})();
